exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".plus-display-layer{cursor:pointer}.plus-display-layer .legend{bottom:0;left:0;text-shadow:0 0 24px rgba(0,0,0,.6)}.plus-display-layer .legend.color-white{text-shadow:0 0 24px hsla(0,0%,100%,.6)}.plus-display-layer .plus{right:.5rem;top:.5rem;transition:all .3s}.plus-display-layer:hover .plus{transform:rotate(180deg)}", ""]);

